module.exports = __webpack_public_path__ + "static/media/amine.9a131525.webp";